import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAppContext } from "../utils/context/app-context";
import { TextInput } from "../components/FormComponents";
import useDocumentTitle from "../components/useDocumentTitle";

function Login() {
	let navigate = useNavigate();
	useDocumentTitle("Login");
	let { api, state } = useAppContext();
	const isOffline = state.offline;

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [formErrors, setFormErrors] = useState({});
	const [loginError, setLoginError] = useState(null);
	const [submitting, setSubmitting] = useState(false);

	function handleEmailChange(e) {
		setEmail(e.target.value);
	}

	function handlePasswordChange(e) {
		setPassword(e.target.value);
	};

	async function handleSubmit(e) {
		e.preventDefault();
		setLoginError(null);
		let errors = {};
		
		if (!email) {
			errors.email = "Email is required";
		}
		
		if (!password) {
			errors.password = "Password is required";
		}

		setFormErrors(errors);
		
		if (Object.keys(errors).length) {
			return;
		}
		setSubmitting(true);

		const loginResult = await api.login(email, password);
		if (loginResult?.success) {
			console.log('here')
			navigate('/', { replace: true });
		} else {
			setLoginError(loginResult?.error || 'An error occurred')
			setSubmitting(false);
		}
	}
	
	return (
		<div>
			{!isOffline && (
				<h1>Welcome Tutors, please log in below</h1>
			)}
			{isOffline && <div className="alert-banner alert-banner__danger mb-3">Sorry, you cannot login while offline</div>}
			<form>
				<TextInput
					label="Email"
					name="email"
					type="email"
					value={email}
					onChange={handleEmailChange}
					required={true}
					error={formErrors?.email}
				/>
				<TextInput
					label="Password"
					name="password"
					type="password"
					value={password}
					onChange={handlePasswordChange}
					required={true}
					error={formErrors?.password}
				/>
				{loginError && <div className="alert-banner alert-banner__danger">{loginError}</div>}
				<div className="auth-info-container__login-bottom">
					<button
						type="submit"
						className="btn btn-tertiary auth-info-container__button"
						onClick={handleSubmit}
						disabled={submitting || isOffline}
					>
						{submitting ? 'Logging In...' : 'Login'}
					</button>
					{!isOffline && (
						<p className="auth-info-container__small-link">
							<Link to="/forgotten-password">Forgotten Password?</Link>
						</p>
					)}
				</div>
			</form>
		</div>
	);
}

export default Login;